import { dynamicElementsTextKey } from '@epicuro-next/constants/dynamic-elements';
import {
  LIST_ACCESS_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export const listNameNonEditableItem: IDynamicItem = {
  contentTypeId: dynamicElementsTextKey,
  styles: {
    classes: ['px-1', 'text-center'],
    variables: {
      '--text-editable-dynamic-font-size': '1.75rem',
      '--text-editable-dynamic-font-weight': '500',
    },
  },
  inputs: {
    text: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'name',
    },
  },
};

// Bestseller
export const listNameEditableItem: IDynamicItem = {
  contentTypeId: dynamicElementsTextKey,
  styles: {
    variables: {
      '--text-editable-dynamic-font-size': '2rem',
      '--text-editable-dynamic-font-weight': '700',
      '--text-editable-dynamic-text-align': 'center',
    },
  },
  inputs: {
    text: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'name',
    },
    isEditAllowed: {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListAllowedForEdit',
    },
    isMultiline: false,
    isRequired: true,
    maxCharacters: 50,
    placeholder: '@@formInputListNamePlaceholder',
  },
};
